export function uppercaseFirstLetter (value: string): string {
  if (!value || typeof value !== 'string') return ''

  const firstChar = value.charAt(0).toUpperCase()
  const rest = value.substring(1)

  return `${firstChar}${rest}`
}
